import React, { useState } from 'react'
import './PickupOrderHistoryModal.scss';

import { Button } from '../../Components/StyledComponents';
import DatePicker from '../../Components/DatePicker/DatePicker';
import moment from 'moment';
import CheckBox from '../../Components/CheckBox/CheckBox';
import { alertRef } from '../../App';

const PickupOrderHistoryModal = ({downLoadHistory, isDownloading}) => {
    const [checked, setChecked] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const formatDate = (date) => moment(date).format("YYYY-MM-DD");

    const downLoad = () => {
        downLoadHistory(formatDate(startDate), formatDate(endDate), checked);
    };

    const getMaxEndDate = () => {
        if(startDate === null) {
            return null;
        } else if(startDate < moment().add(-30, 'days').toDate()) {
            return moment(startDate).add(30, 'days').toDate();
        } else {
            return moment().toDate();
        }
    }

    const updateStartDate = (date) => {
        setEndDate(null)
        setStartDate(date)
    }

    return (
        <div>
            <div style={{height: 200}}>
                <div className='row'>
                    <p className='label' style={{flex: 1}}>다운로드 기간</p>
                    <DatePicker
                        value={startDate}
                        maxDate={moment().toDate()}
                        onChange={updateStartDate}
                        style={{ width : 150 }}
                    />
                    <span style={{margin: '0 10px'}}>~</span>
                    <DatePicker
                        value={endDate}
                        minDate={startDate}
                        maxDate={getMaxEndDate()}
                        onChange={(date) => setEndDate(date)}
                        style={{ width : 150 }}
                    />
                </div>
                <p className='label' style={{width: '100%', textAlign: 'right', marginTop: 8}}>다운로드 기간은 최대 30일까지 설정 가능합니다.</p>
            </div>

            <div>
                <div className='btn-row' style={{flexDirection: 'column', alignItems: 'flex-end'}}>
                    <div className="row">
                        <CheckBox
                            containerStyle={{ marginBottom : 16 }}
                            checked={checked}
                            label="카드사별 결제금액 내역 포함"
                            onChange={() => {
                                if(!checked) {
                                    alertRef.current.showAlert({ title: '시간이 오래 소요될 수 있습니다.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                                }
                                setChecked(prev => !prev)
                            }}
                        />
                    </div>
                    <Button variant="main" className='save-btn' fontSize={16} onClick={downLoad} disabled={startDate === null || endDate === null || isDownloading}>
                        {isDownloading ? '다운로드 중...' : '다운로드'}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default PickupOrderHistoryModal;